export default __webpack_public_path__ + "static/lufthansa-city-center_1_1_en-e0cfd6bbbfa2db6028f75c4cc1dbfa30.png";